// import { useSurveyCardsStore } from "@stores/survey/surveyCards";
import { deepCopy } from "@utils/toolBox";
import { createAnswerItem, createImageItem } from "@stores/survey/cardPayloadHandler";

const findCardByToken = ({ cards, token }) => cards.find((card) => card.token === token);

export const updateAnswersFromSourceCard = ({ cards, sourceCardToken, targetCard, recursive = true }) => {
  const sourceCard = findCardByToken({ cards, token: sourceCardToken });
  if (!sourceCard) return;

  const targetCardType = targetCard.type.match(/q_image_choice/) ? "image" : "answer";
  if (
    sourceCard.specs.has_dynamic_answers &&
    !sourceCard.specs.dynamic_answers_custom &&
    sourceCard.specs.dynamic_answers_source_question_token &&
    recursive
  ) {
    updateAnswersFromSourceCard({
      cards,
      sourceCardToken: sourceCard.specs.dynamic_answers_source_question_token,
      targetCard: sourceCard,
    });
  }
  const sourceAnswers = sourceCard.specs.answers || [];
  const newAnswers = sourceAnswers.map((answer, index) => {
    const base = targetCard.specs.answers[index] || (targetCardType === "answer" ? createAnswerItem(index) : createImageItem(index));
    const newAnswer = { ...base, token: answer.token, title: deepCopy(answer.title) };
    if (targetCardType === "image") {
      newAnswer.file_type = answer.file_type;
      newAnswer.url = deepCopy(answer.url);
      newAnswer.attachment = answer.attachment ? deepCopy(answer.attachment) : undefined;
    }
    return newAnswer;
  });
  if (JSON.stringify(newAnswers) !== JSON.stringify(targetCard.specs.answers)) targetCard.specs.answers = newAnswers;
};
